import { render, staticRenderFns } from "./RevenueAndProfit.vue?vue&type=template&id=1f6b999a&"
import script from "./RevenueAndProfit.vue?vue&type=script&lang=js&"
export * from "./RevenueAndProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RevenueAndProfit.vue"
export default component.exports